<template>
  <div>
    <el-dialog
      title="Edit Track"
      :visible="dialog_track"
      width="740px"
      top="3vh"
      :modal="true"
      @close="close"
      @open="open"
      :close-on-click-modal="false"
    >
      <div class="image">
        <div v-if="!image && !previewImage" class="image--uploader">
          <label for="imageFile" class="image-uploader"><i class="el-icon-plus fa-2x"></i></label>
          <input type="file" id="imageFile" accept="image/png, image/jpeg, image/jpg" v-show="false" @change="uploadImage">
        </div>
        <div v-else class="image--preview">
          <img height="120" width="120" :src="image ? image : previewImage" alt="image">
          <div class="overlay" @click="removeImage">
            <el-button
                class="btn-remove"
                icon="fas fa-trash"
                circle
            ></el-button>
          </div>
        </div>
      </div>
      <el-form ref="track" :model="track" label-position="top">
        <div v-if="+track.user_publish !== 2" class="mt20" style="text-align: center">
          <el-switch  v-model="track.delivered"
                     active-text="Delivered" inactive-text="Not Delivered"
                     active-color="#13ce66" inactive-color="#df2758"
          ></el-switch>
        </div>
        <el-form-item label="Title" prop="title" required>
          <el-input type="text" v-model="track.title" clearable />
        </el-form-item>
        <el-form-item
          label="Artist"
          prop="artist_id"
          :rules="[{ required: true, message: 'artist is required' }]"
        >
          <el-select
            v-model="track.artist_id"
            clearable
            filterable
            class="mr10 w90"
          >
            <el-option
              v-for="a in artists"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
          <el-tooltip content="Add new artist" placement="top">
            <el-button
              icon="el-icon-plus"
              type="success"
              circle
              @click="openArtist"
            ></el-button>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="ISRC" prop="isrc">
          <el-input type="text" v-model="track.isrc" clearable />
        </el-form-item>
        <el-form-item label="Platforms" prop="type">
          <el-select v-model="track.platforms" filterable multiple class="mr10 capitalize">
            <el-option v-for="social in socials" :key="social.id" :value="social.name" :label="social.name"></el-option>
          </el-select>
        </el-form-item>
        <div class="tiktok_data" v-if="hasSocial('TikTok')">
          <div  class="title" :class="tiktokData === true ? 'active' : ''"
                @click="tiktokStatus(tiktokData)">TikTok Challenge
            <i class="arrow down" v-if="!tiktokData"></i>
            <i  v-else class="arrow up"></i>
          </div>
          <div v-if="tiktokData">
            <el-form-item label="Challenge Link" prop="tiktok_challenge.link" required>
              <el-input type="text" v-model="track.tiktok_challenge.link" clearable />
            </el-form-item>
            <el-form-item label="Challenge Budget" prop="tiktok_challenge.budget" required>
              <el-input type="number" v-model="track.tiktok_challenge.budget" clearable />
            </el-form-item>
            <el-form-item
              label="Challenge Timing"
              prop="tiktok_challenge.date_end"
            >
              <el-input
                type="hidden"
                v-model="track.tiktok_challenge.date_end"
                clearable
                style="width: 0px;"
              />
              <el-date-picker
                v-model="tiktokDatePicker"
                type="daterange"
                format="d MMMM yyyy"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                @change="changeTikTokPicker"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="Steps title" prop="challenge_title">
              <el-input type="text" v-model="track.tiktok_challenge.campaign_main_title" clearable />
            </el-form-item>
            <el-form-item label="Steps" prop="tiktok_challenge.steps" required>
              <vue-editor v-model="track.tiktok_challenge.steps"  />
            </el-form-item>
            <el-form-item label="Top tips" prop="tiktok_challenge.top_tips" required>
              <vue-editor v-model="track.tiktok_challenge.top_tips"  />
            </el-form-item>
            <el-form-item label="Bonus" prop="challenge_bonus_desc">
              <el-input type="text" v-model="track.tiktok_challenge.bonus_desc"  clearable />
            </el-form-item>
            <el-form-item label="Bonus payment" prop="challenge_bonus_payment">
              <el-input type="number" v-model="track.tiktok_challenge.bonus_payment" clearable />
            </el-form-item>
            <el-form-item label="Guaranteed" prop="challenge_guaranteed_desc">
              <el-input type="text" v-model="track.tiktok_challenge.guaranteed_desc" clearable />
            </el-form-item>
            <el-form-item label="Guaranteed payment" prop="challenge_guaranteed_payment">
              <el-input type="number" v-model="track.tiktok_challenge.guaranteed_payment" clearable />
            </el-form-item>
            <el-form-item label="Earn Up" prop="tiktok_challenge.earn_up">
              <el-input type="text" v-model="track.tiktok_challenge.earn_up"  clearable />
            </el-form-item>
            <el-form-item label="Free To Use" prop="tiktok_challenge.free_to_use">
              <el-input type="text" v-model="track.tiktok_challenge.free_to_use"  clearable />
            </el-form-item>
          </div>
        </div>
        <!--instagram challenge-->
        <div class="instagram_data" v-if="hasSocial('Instagram')">
          <div class="title" :class="instagramData === true ? 'active' : ''"
               @click="instagramStatus(instagramData)">Instagram Challenge
            <i class="arrow down" v-if="!instagramData"></i>
            <i v-else class="arrow up"></i>
          </div>
          <div v-if="instagramData">
            <el-form-item label="Challenge Link" prop="instagram_challenge.link" required>
              <el-input type="text" v-model="track.instagram_challenge.link" clearable />
            </el-form-item>
            <el-form-item label="Challenge Budget" prop="instagram_challenge.budget" required>
              <el-input type="number" v-model="track.instagram_challenge.budget" clearable />
            </el-form-item>
            <el-form-item
              label="Challenge Timing"
              prop="instagram_challenge.date_start"
              :rules="[{ required: true, message: 'timing is required' }]"
              style="margin-bottom: 25px;"
            >
              <el-input
                type="hidden"
                v-model="track.instagram_challenge.date_start"
                clearable
                style="width: 0px;"
              />
              <el-date-picker
                v-model="instagramDatePicker"
                type="daterange"
                format="d MMMM yyyy"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                @change="changeInstagramPicker"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="Steps title" prop="instagram_challenge.campaign_main_title">
              <el-input type="text" v-model="track.instagram_challenge.campaign_main_title" clearable />
            </el-form-item>
            <el-form-item label="Steps" prop="instagram_challenge.steps" required>
              <vue-editor v-model="track.instagram_challenge.steps" />
            </el-form-item>
            <el-form-item label="Top tips" prop="instagram_challenge.top_tips" required>
              <vue-editor v-model="track.instagram_challenge.top_tips" />
            </el-form-item>
            <el-form-item label="Bonus" prop="instagram_challenge.bonus_desc">
              <el-input type="text" v-model="track.instagram_challenge.bonus_desc" clearable />
            </el-form-item>
            <el-form-item label="Bonus payment" prop="instagram_challenge.bonus_payment">
              <el-input type="number" v-model="track.instagram_challenge.bonus_payment" clearable />
            </el-form-item>
            <el-form-item label="Guaranteed" prop="instagram_challenge.guaranteed_desc">
              <el-input type="text" v-model="track.instagram_challenge.guaranteed_desc" clearable />
            </el-form-item>
            <el-form-item label="Guaranteed payment" prop="instagram_challenge.guaranteed_payment">
              <el-input type="number" v-model="track.instagram_challenge.guaranteed_payment" clearable />
            </el-form-item>
            <el-form-item label="Earn Up" prop="instagram_challenge.earn_up">
              <el-input type="text" v-model="track.instagram_challenge.earn_up" clearable />
            </el-form-item>
            <el-form-item label="Free To Use" prop="instagram_challenge.free_to_use">
              <el-input type="text" v-model="track.instagram_challenge.free_to_use" clearable />
            </el-form-item>
          </div>
        </div>
        <!--shorts challenge-->
        <div class="shorts_data" v-if="hasSocial('YouTube Short')">
          <div class="title" :class="shortsData === true ? 'active' : ''"
               @click="shortsStatus(shortsData)">YouTube Shorts Challenge
            <i class="arrow down" v-if="!shortsData"></i>
            <i  v-else class="arrow up"></i>
          </div>
          <div v-if="shortsData">
            <el-form-item label="Challenge Link" prop="short_challenge.link" required>
              <el-input type="text" v-model="track.short_challenge.link" clearable />
            </el-form-item>
            <el-form-item label="Challenge Budget" prop="short_challenge.budget" required>
              <el-input type="number" v-model="track.short_challenge.budget" clearable />
            </el-form-item>
            <el-form-item
              label="Challenge Timing"
              prop="short_challenge.date_end"
            >
              <el-input
                type="hidden"
                v-model="track.short_challenge.date_end"
                clearable
                style="width: 0px;"
              />
              <el-date-picker
                v-model="shortDatePicker"
                type="daterange"
                format="d MMMM yyyy"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                @change="changeShortPicker"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="Steps title" prop="short_title">
              <el-input type="text" v-model="track.short_challenge.campaign_main_title" clearable />
            </el-form-item>
            <el-form-item label="Steps" prop="short_challenge.steps" required>
              <vue-editor v-model="track.short_challenge.steps" />
            </el-form-item>
            <el-form-item label="Top tips" prop="short_challenge.top_tips" required>
              <vue-editor v-model="track.short_challenge.top_tips"  />
            </el-form-item>
            <el-form-item label="Bonus" prop="challenge_bonus_desc">
              <el-input type="text" v-model="track.short_challenge.bonus_desc"  clearable />
            </el-form-item>
            <el-form-item label="Bonus payment" prop="challenge_bonus_payment">
              <el-input type="number" v-model="track.short_challenge.bonus_payment"  clearable />
            </el-form-item>
            <el-form-item label="Guaranteed" prop="challenge_guaranteed_desc">
              <el-input type="text" v-model="track.short_challenge.guaranteed_desc"  clearable />
            </el-form-item>
            <el-form-item label="Guaranteed payment" prop="challenge_guaranteed_payment">
              <el-input type="number" v-model="track.short_challenge.guaranteed_payment"  clearable />
            </el-form-item>
            <el-form-item label="Earn Up" prop="short_challenge.earn_up">
              <el-input type="text" v-model="track.short_challenge.earn_up"  clearable />
            </el-form-item>
            <el-form-item label="Free To Use" prop="short_challenge.free_to_use">
              <el-input type="text" v-model="track.short_challenge.free_to_use"  clearable />
            </el-form-item>
          </div>
        </div>
        <!--youtube regular-->
        <div class="youtube_data" v-if="hasSocial('YouTube')">
          <div class="title" :class="youtubeData === true ? 'active' : ''"
               @click="youtubeStatus(youtubeData)">YouTube Regular
            <i class="arrow down" v-if="!youtubeData"></i>
            <i v-else class="arrow up"></i>
          </div>
          <div v-if="youtubeData">
            <el-form-item label="Challenge Main Title" prop="challenge_title">
              <el-input type="text" v-model="track.regular_challenge.campaign_main_title" clearable />
            </el-form-item>
            <el-form-item label="Steps" prop="steps">
              <vue-editor v-model="track.regular_challenge.steps" />
            </el-form-item>
            <el-form-item label="Top tips" prop="top_tips">
              <vue-editor v-model="track.regular_challenge.top_tips" />
            </el-form-item>
            <el-form-item label="Earn Up" prop="regular_challenge.earn_up">
              <el-input type="text" v-model="track.regular_challenge.earn_up"  clearable />
            </el-form-item>
            <el-form-item label="Free To Use" prop="regular_challenge.free_to_use">
              <el-input type="text" v-model="track.regular_challenge.free_to_use"  clearable />
            </el-form-item>
          </div>
        </div>
        <el-form-item label="Genres" prop="genres">
          <el-select v-model="track.genres" multiple placeholder="Select">
            <el-option v-for="item in genres" :key="item.id" :label="item.name" :value="item.cyaniteName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Moods" prop="moods">
          <el-select v-model="track.moods" multiple placeholder="Select">
            <el-option v-for="item in moods" :key="item.id" :label="item.name" :value="item.cyaniteName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="BPM" prop="bpm">
          <el-input type="text" v-model="track.bpm" clearable />
        </el-form-item>
        <el-form-item label="FFM Link" prop="ffm_link">
          <el-input type="text" v-model="track.ffm_link" clearable />
        </el-form-item>
        <el-form-item label="Album" prop="album">
          <el-input type="text" v-model="track.album" clearable />
        </el-form-item>
        <el-form-item label="Record Label" prop="record_label">
          <el-input type="text" v-model="track.record_label" clearable />
        </el-form-item>
        <el-form-item class="smart-links">
          <el-button @click="addSmartLink">Add Smart Link</el-button>
          <small>(You can add maximum 3 smart links)</small>
        </el-form-item>
        <div v-for="(link, index) in track.smartLinks" :key="link.key">
          <el-form-item class="smart-link-input" :label="`Smart Link ${index + 1}`"
                        :prop="'smartLinks.' + index + 'value'">
            <el-input v-model="link.value"></el-input>
            <el-button @click.prevent="removeSmartLink(link)">Delete</el-button>
          </el-form-item>
          <el-form-item class="smart-link-input" :label="`Smart Link Description ${index + 1}`"
                        :prop="'smartLinks.' + index + 'description'" >
            <el-input v-model="link.description"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="Description" prop="description">
          <el-input type="textarea" size="medium" maxlength="300" rows="5" :show-word-limit="true"
                    placeholder="Description" v-model="track.description"></el-input>
        </el-form-item>
        <el-form-item label="Blue box text" prop="card_bar_desc">
          <el-input type="text" v-model="track.card_bar_desc" clearable maxlength = "30"/>
        </el-form-item>
        <el-form-item label="Select Restrictions" prop="restrictions">
          <el-checkbox-group v-model="track.restrictions">
            <el-checkbox v-for="r in restrictionNames" :key="getTime() + r" :label="r"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="Timing"
          prop="timing_start"
        >
          <el-input
            type="hidden"
            v-model="track.timing_start"
            clearable
            style="width: 0px;"
          />
          <el-date-picker
            v-model="datePicker"
            type="daterange"
            format="d MMMM yyyy"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="changePicker"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="info" size="mini" @click="previewTemplate">Preview</el-button>
        <el-button type="primary" size="mini" :loading="loading" @click="submit()">Save</el-button>
      </div>
    </el-dialog>
    <DialogArtist />
    <DialogUpload />
    <PreviewImport :restrictions="restrictionNames" :track="track" />
    <DDEX/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import DialogArtist from './DialogArtist'
import DialogUpload from './DialogUpload'
import UploadImage from './UploadImageImport'
import DDEX from './DDEX'
import PreviewImport from '@/modules/admin/track-import/components/PreviewImportInMail'
import { VueEditor } from "vue2-editor";

export default {
  components: {
    DialogArtist,
    DialogUpload,
    UploadImage,
    PreviewImport,
    VueEditor,
    DDEX
  },

  props: ['page'],

  watch: {
    dialog_artist: function(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.readArtist()
      }
    }
  },

  data() {
    return {
      datePicker: [],
      shortDatePicker: [],
      tiktokDatePicker: [],
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      selectedImage: null,
      previewImage: null,
      tiktokData: false,
      instagramDatePicker: [],
      instagramData: false,
      shortsData:false,
      youtubeData:false,
    }
  },

  computed: {
    ...mapState('trackImport', [
      'loading',
      'track',
      'data',
      'dialog_track',
      'dialog_artist',
      'dialog_upload',
      'socials',
      'tiktok_pricing',
      'short_pricing',
    ]),
    ...mapState('global', ['preview']),
    ...mapState('trackImport', ['artists', 'genres', 'moods', 'restrictions']),

    restrictionNames() {
      let rNames = this.restrictions.map(r => r.name)
      if (this.track.restrictions && this.track.restrictions.length === 0) {
        this.setTrackRestrictions(rNames)
      }
      return rNames
    },
    image() {
      return this.track.image_url instanceof File ? null : this.track.image_url
    }
  },

  methods: {
    ...mapActions('trackImport', ['update', 'readArtist']),
    ...mapMutations('trackImport', [
      'setTrack',
      'setDialogTrack',
      'setDialogArtist',
      'setTiming',
      'setTrackRestrictions',
      'setTrackSmartLinks',
      'setImage',
      'setDialogDDEX',
    ]),
    ...mapMutations('global', ['setPreview']),
    ...mapMutations('newReleasesArtists', [
      'setMetadata',
      'setSocial',
      'setArtistID'
    ]),

    previewTemplate() {
      this.setPreview(true)
    },

    getTime() {
      return new Date().getTime()
    },

    submit() {
      if (this.selectedImage) this.setImage(this.selectedImage)
      //if(this.track.type != 'nft') this.track.nft_description = null
      this.update({id: this.track.id, page: this.page})
    },

    onSuccess(response, file) {
      this.$message({ type: 'success', message: `File ${file} uploaded` })
    },

    onError() {
      this.$message({ type: 'error', message: 'Upload error' })
    },

    openArtist() {
      this.setDialogArtist({ status: true, type: 'Create', id: null })
      this.setArtistID(null)
      this.setMetadata({})
      this.setSocial({})
    },

    hasSocial(platform) {
      return  this.track.platforms
              && !!this.track.platforms.find(p => p === platform)
    },

    open() {
      this.readArtist()
      this.datePicker = []
      if (
        typeof this.track.timing_start !== 'undefined' &&
        typeof this.track.timing_end !== 'undefined' &&
        this.track.timing_start !== null &&
        this.track.timing_end !== null
      ) {
        this.datePicker[0] = this.track.timing_start
        this.datePicker[1] = this.track.timing_end
      }
      this.shortDatePicker = []
      if (
        typeof this.track.short_challenge.date_start !== 'undefined' &&
        typeof this.track.short_challenge.date_end !== 'undefined' &&
        this.track.short_challenge.date_start !== null &&
        this.track.short_challenge.date_end !== null
      ) {
        this.shortDatePicker[0] = this.track.short_challenge.date_start
        this.shortDatePicker[1] = this.track.short_challenge.date_end
      }

      this.tiktokDatePicker = []
      if (
        typeof this.track.tiktok_challenge.date_start !== 'undefined' &&
        typeof this.track.tiktok_challenge.date_end !== 'undefined' &&
        this.track.tiktok_challenge.date_start !== null &&
        this.track.tiktok_challenge.date_end !== null
      ) {
        this.tiktokDatePicker[0] = this.track.tiktok_challenge.date_start
        this.tiktokDatePicker[1] = this.track.tiktok_challenge.date_end
      }

      this.instagramDatePicker = []
      if (
        typeof this.track.instagram_challenge.date_start !== 'undefined' &&
        typeof this.track.instagram_challenge.date_end !== 'undefined' &&
        this.track.instagram_challenge.date_start !== null &&
        this.track.instagram_challenge.date_end !== null
      ) {
        this.instagramDatePicker[0] = this.track.instagram_challenge.date_start
        this.instagramDatePicker[1] = this.track.instagram_challenge.date_end
      }
      this.previewImage = null;
    },

    changePicker() {
      if (typeof this.datePicker !== 'undefined' && this.datePicker !== null) {
        this.setTiming({
          date_start: this.datePicker[0],
          date_end: this.datePicker[1]
        })
      } else {
        this.setTiming({
          date_start: null,
          date_end: null
        })
      }
    },
    changeShortPicker() {
      if (typeof this.shortDatePicker !== 'undefined' && this.shortDatePicker !== null) {
        this.track.short_challenge.date_start = this.shortDatePicker[0]
        this.track.short_challenge.date_end = this.shortDatePicker[1]
      } else {
        this.track.short_challenge.date_start = null
        this.track.short_challenge.date_end =  null
      }
    },
    changeTikTokPicker() {
      if (typeof this.tiktokDatePicker !== 'undefined' && this.tiktokDatePicker !== null) {
        this.track.tiktok_challenge.date_start = this.tiktokDatePicker[0]
        this.track.tiktok_challenge.date_end = this.tiktokDatePicker[1]
      } else {
        this.track.tiktok_challenge.date_start = null
        this.track.tiktok_challenge.date_end =  null
      }
    },
    changeInstagramPicker() {
      if (typeof this.instagramDatePicker !== 'undefined' && this.instagramDatePicker !== null) {
        this.track.instagram_challenge.date_start = this.instagramDatePicker[0]
        this.track.instagram_challenge.date_end = this.instagramDatePicker[1]
      } else {
        this.track.instagram_challenge.date_start = null
        this.track.instagram_challenge.date_end =  null
      }
    },

    addSmartLink() {
      let trackSmartLink = this.track.smartLinks
      if (trackSmartLink && trackSmartLink.length === 3) return

      trackSmartLink.push({key: new Date().getTime(), value: ''})
      this.setTrackSmartLinks(trackSmartLink)
    },

    removeSmartLink(link) {
      let trackSmartLink = this.track.smartLinks
      const index = trackSmartLink.indexOf(link);

      if (index !== -1) {
        trackSmartLink.splice(index, 1);
      }
      this.setTrackSmartLinks(trackSmartLink)
    },

    close() {
      this.setDialogTrack(false)
      this.previewImage = null;
    },

    uploadImage(event) {
      if (event.target.files && event.target.files[0]) {
        let base64 = null
        // Encode the file using the FileReader API
        const reader = new FileReader();
        reader.onloadend = () => {
          // Use a regex to remove data url part
          this.selectedImage = reader.result
        };
        reader.readAsDataURL(event.target.files[0]);
        this.previewImage = URL.createObjectURL(event.target.files[0])
      }
    },

    removeImage() {
      this.track.image_url = null
      this.setImage(null)
      this.selectedImage = null
      this.previewImage = null
    },
    tiktokStatus(info){
      this.tiktokData = !info
    },
    instagramStatus(info){
      this.instagramData = !info
    },
    shortsStatus(info){
      this.shortsData = !info
    },
    youtubeStatus(info){
      this.youtubeData = !info
    },
    showDDEX(){
      this.setDialogDDEX(true)
    }
  },
}
</script>

<style scoped lang="scss">

label.el-checkbox {
  display: inline-block;
}

.smart-links {
  small {
    margin-left: 10px;
  }
}

.smart-link-input {
  .el-input {
    width: 70%;
    margin-right: 10px;
  }
}
.image {
  &--uploader {
    label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      width: 120px;
      height: 120px;
      border: 1px dashed #d9d9d9;
      cursor: pointer;
    }
  }
  &--preview {
    text-align: center;
    position: relative;

    img{
      object-fit: cover;
    }

    &:hover {
      .overlay {
        display: flex;
        .btn-remove{
          background: red;
          color: white;
          margin-top: unset;
          cursor: pointer;
        }
      }
    }

    .overlay {
      position: absolute;
      z-index: 5;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      height: 100%;
      background: rgba(0, 0, 0, .1);
      display: none;
      align-items: center;
      justify-content: center;
    }
  }
}
.tiktok_data, .shorts_data, .youtube_data, .instagram_data{
  border: 1px solid;
  padding: 20px;
  border-radius: 10px;
  margin: 20px 0;
  .title{
    color:#000;
    text-transform: uppercase;
    border-bottom: 1px solid;
    text-align: center;
    cursor: pointer;
    padding-bottom: 10px;
  }
  .arrow {
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
  }
  .up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }

  .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
}
</style>
